/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type TaxAccountantRequest = {
    licenceId?: string;
    softwareName?: TaxAccountantRequest.softwareName;
    softwarePath?: string;
    unitsPath?: string;
    userId?: string;
    valid?: boolean;
    licenceAdmin?: boolean;
};

export namespace TaxAccountantRequest {
    export enum softwareName {
        POHODA = "POHODA",
        POHODA_SQL = "POHODA_SQL",
        FLEXIBEE = "FLEXIBEE",
        MONEYS3 = "MONEYS3",
        MONEYS3_API = "MONEYS3_API",
        ISDOC = "ISDOC",
        OTHER = "OTHER",
    }
}
